import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { checkPassword } from '../../../../utils/validation';

export default function PasswordInput({
    value,
    onChange,
    onBlur,
    errorProp = '',
    id,
}) {
    const [passwordErrors, setPasswordErrors] = useState([]);
    const [showError, setShowError] = useState(false);
    const [errorShown, setErrorShown] = useState(false)

    function onPasswordBlur(e) {
        const val = e.target.value;
        const errors = checkPassword(val);
        if ((val?.length || errorShown) && errors?.length) {
            setPasswordErrors(errors);
            setShowError(true);
            setErrorShown(true)
        }
        onBlur && onBlur(e);
    }

    function onFocus() {
        setPasswordErrors([]);
        setShowError(false);
    }

    function onPasswordChange(e) {
        const password = e.target.value;
        const errors = checkPassword(password);
        onChange && onChange({ password, validPassword: !errors.length });
    }

    useEffect(() => {
        if (errorProp.length) {
            setPasswordErrors([errorProp])
            setShowError(true);
            setErrorShown(true)
        }
    }, [errorProp])

    const errorDisplay = passwordErrors.map(error => (<li>{error}</li>));
    return (
        <>
            <input
                type="password"
                name="password"
                className={classNames({ 'has-error': showError})}
                onChange={onPasswordChange}
                onBlur={onPasswordBlur}
                onFocus={onFocus}
                value={value}
                id={id}
            />
            <p className={classNames(
                'error-message',
                { 'hide-error': !showError },
            )}><ul>{errorDisplay}</ul></p>
        </>
    );
}
